import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [qty, setQty] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, qty, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <Header />

      <main className="pd">
        <section className="pd-grid">
          <div className="pd-left">
            <div className="pd-thumbs">
              {(product.images?.length ? product.images : [product.image]).map(
                (img, i) => (
                  <button
                    className={
                      "pd-thumb " + (i === selectedImage ? "active" : "")
                    }
                    key={i}
                    onClick={() => setImage(i)}
                    aria-label={"Image " + (i + 1)}
                  >
                    <img
                      src={img}
                      alt={product.name + " thumbnail " + (i + 1)}
                    />
                  </button>
                )
              )}
            </div>
            <div className="pd-media">
              <img
                src={
                  (product.images?.length ? product.images : [product.image])[
                  selectedImage
                  ]
                }
                alt={product.name}
              />
            </div>
          </div>

          <div className="pd-right">
            <div className="pd-badges">
              <span className="chip chip--primary">New</span>
              <span className="chip chip--primary">Best Seller</span>
            </div>
            <h1 className="pd-name">{product.name}</h1>
            <div className="pd-sub">Featuring Retinal 2K</div>
            <div className="pd-rating">
              <span className="pd-rating-num">
                {Number(product.rating).toFixed(1)}
              </span>
              <span className="pd-rating-stars">★★★★★</span>
              <span className="pd-reviews">{product.reviews}</span>
            </div>
            <div className="pd-price">€{Number(product.price).toFixed(2)}</div>
            <div className="pd-finance">
              <Link to="/terms" onClick={toTop}>
                See if you qualify.
              </Link>
            </div>

            <div className="pd-form">
              {product.colors?.length ? (
                <>
                  <label className="pd-label">Color</label>
                  <div className="pd-select">
                    <select
                      value={selectedColor}
                      onChange={(e) => setSelectedColor(e.target.value)}
                    >
                      {product.colors.map((c) => (
                        <option value={c} key={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : null}

              {product.size?.length ? (
                <>
                  <label className="pd-label">Size</label>
                  <div className="pd-select">
                    <select
                      value={selectedSize}
                      onChange={(e) => setSelectedSize(e.target.value)}
                    >
                      {product.size.map((s) => (
                        <option value={s} key={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : null}

              <label className="pd-label">Quantity</label>
              <div className="pd-select">
                <select
                  value={qty}
                  onChange={(e) => setQty(Number(e.target.value))}
                >
                  {[1, 2, 3, 4, 5].map((n) => (
                    <option value={n} key={n}>
                      {n}-pack
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="pd-features">
              {(product.description || []).map((d, i) => (
                <p key={i}>{d}</p>
              ))}

              <ul>
                {(product.Features || []).map((d, i) => (
                  <li key={i}>{d}</li>
                ))}
              </ul>
            </div>

            <div className="pd-suggest">
              <div className="pd-suggest-title">You might also like</div>
              <div className="pd-suggest-grid">
                {productData
                  .filter((x) => x.id !== product.id)
                  .slice(0, 3)
                  .map((s) => (
                    <Link
                      to={`/shopDetails/${s.id}`}
                      className="pd-suggest-card"
                      key={s.id}
                      onClick={toTop}
                    >
                      <div className="pd-suggest-name">{s.name}</div>
                      <div className="pd-suggest-price">
                        €{Number(s.price).toFixed(2)}
                      </div>
                    </Link>
                  ))}
              </div>
            </div>

            <div className="pd-delivery">Fastest delivery on Mon, Mar 9</div>
            <button className="pd-add btn primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ProductDetail;
